import { render } from "./KoruPlaces.vue?vue&type=template&id=65d691a8&ts=true"
import script from "./KoruPlaces.vue?vue&type=script&lang=ts"
export * from "./KoruPlaces.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__